export default {"src":"/_next/static/media/web3.0389269e.svg","height":59,"width":94};